import React from 'react'
import { connect } from 'react-redux'
import userActions from '../common/actions/user.js'
import { bindActionCreators } from 'redux'
import parseQuery from './parser.js'
import { Col, Row, Grid, SplitButton, MenuItem } from 'react-bootstrap'
import { confirmAlert } from 'react-confirm-alert'
import phone from 'phone'
import emailValidator from 'email-validator'
import { RegionDropdown } from 'react-country-region-selector'
import propTypeSchema from 'react-json-schema-proptypes'
import { SubscribeExtraFields, PlainText } from '../../src/donate/types'
import get from 'lodash/get'
import ReCAPTCHA from 'react-google-recaptcha'
import { Style } from 'radium'
import { isEmpty, trim } from 'lodash'
import { getStore } from '../common/store'

export const schema = {
  'type': 'object',
  'properties': {
    'target': { 'type': 'string' },
    'customSubscribe': {
      'type': 'object',
      'properties': {
        'title': { 'type': 'string' },
        'subtitle': { 'type': 'string' },
        'buttonLabel': { 'type': 'string' },
        'mobileFieldRequired': { 'type': 'boolean' },
        'successMessage': { 'type': 'string' },
        'errorMessage': { 'type': 'string' },
        'subscribeSegment': { 'type': 'string' },
        'extraFields': { 'type': 'array', 'items': SubscribeExtraFields.Schema },
        'deleteFields': { 'type': 'array', 'items': PlainText.Schema },
        'hideDefaultFields': { 'type': 'array', 'items': PlainText.Schema},
      }
    }
  }
}

const recaptchaRef = React.createRef()

class Subscribe extends React.Component {

  static propTypes = propTypeSchema(schema)

  constructor(props) {
    super(props)
    this.state = {
      name: '',
      lastName: '',
      email: '',
      mobileNumber: '',
      error: '',
      extraFields: {},
      loading: false,
      recaptchaToken: null,
      messagingAgreement: false
    }
    this.charityName = getStore().getState().config["charityName"];
  }

  componentDidMount() {
    let fromApp = parseQuery.getQueryVariable('fromApp')
    if (fromApp && window.sessionStorage) {
      window.sessionStorage.setItem('fromApp', 'true')
    }
  }

  success() {
    let returnUrl = parseQuery.getQueryVariable('returnUrl')
    if (!returnUrl) {
      returnUrl = '/news-feed'
    } else {
      returnUrl = decodeURIComponent(returnUrl)
    }
    if (this.props.history) { this.props.history.push(returnUrl) }
  }

  allFieldsReady = () => {
    return (this.state.email != "" &&
      this.state.name.replace(/\s/g, '') != "" &&
      this.state.lastName.replace(/\s/g, '') != "") && this.state.messagingAgreement && this.state.recaptchaToken !== null
  }

  submitRecaptcha = (value) => {
    this.setState({
      recaptchaToken: value
    })
  }

  subscribe = () => {

    this.setState({ loading: true })

    let normalizedNumber = null
    let errors = []

    if (this.state.mobileNumber) {
      // Normalize the phone number
      normalizedNumber = phone(this.state.mobileNumber)[0]

      if (!normalizedNumber) {
        errors.push('You must enter a valid phone number.')
      }

      // Not calling setState here is on purpose.
      this.state.mobileNumber = normalizedNumber

    } else if (this.props.customSubscribe && this.props.customSubscribe.mobileFieldRequired) {
      errors.push('You must enter a valid phone number.')
    } else {
      this.state.mobileNumber = null
    }

    if (this.props.customSubscribe && this.props.customSubscribe.extraFields) {
      const extraFields = this.props.customSubscribe.extraFields
      extraFields.map((field) => {
        if (field.required && !this.state.extraFields[field.name]) {
          errors.push('You must enter a valid ' + field.name.toLowerCase() + '.')
        }
      })
    }

    // Validate email address
    let isEmailValid = emailValidator.validate(this.state.email)

    if (!isEmailValid) {
      errors.push('You must enter a valid email address.')
    }

    if (!this.state.messagingAgreement) {
      errors.push('You must accept the messaging conditions')
    }

    if (!this.state.recaptchaToken) {
      errors.push('You must finish the recaptcha')
    }

    if (errors.length > 0) {
      let errorResult = errors.map(errorString => <span>{errorString}<br /></span>)
      this.setState({ error: errorResult, loading: false })
    } else {
      this.setState({ error: null, loading: true })
      this.submit();
    }
  }
  getExtraSegments = () => {
    let segments = []
    let QRCode = parseQuery.getQueryVariable('QRCode')
    let mot = parseQuery.getQueryVariable('mot')
    // NOTE: some charities wanted to start using qrcodes before this feature rolled 
    // out, the only way to track we had was using motivation code, that's why
    // we also use mot==="QRCode" here
    if (QRCode || mot === 'QRCode')
      segments.push('QRCode Subscribers')

    if (this.props.customSubscribe && this.props.customSubscribe.subscribeSegment) {
      segments.push(this.props.customSubscribe.subscribeSegment);
    }

    return segments.length > 0 ? segments.join(';') : null
  }
  getExtraSegmentIds = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const segmentIds = urlParams.get('extraSegmentIds');
    return !isEmpty(trim(segmentIds)) ? segmentIds: null;
  }

  submit() {
    const deleteFields = {}
    if (this.props.customSubscribe && this.props.customSubscribe.deleteFields) {
      this.props.customSubscribe.deleteFields.map(field => {
        deleteFields[field.name] = null
      })
    }

    const target = this.props.target ? { 'target': this.props.target } : {}
    const donor = {
      email: this.state.email,
      firstName: this.state.name,
      lastName: this.state.lastName,
      phoneNumber: this.state.mobileNumber,
      extraFields: { ...this.state.extraFields, ...target, ...deleteFields }
    };

    this.props.userActions
      .subscribeUser(donor, this.state.recaptchaToken, this.getExtraSegments(), this.getExtraSegmentIds())
      .then((success) => {
        recaptchaRef.current.reset()
        this.setState({
          email: "",
          mobileNumber: "",
          lastName: "",
          name: "",
          extraFields: {},
          loading: false,
          recaptchaToken: null,
          messagingAgreement: false
        });

        const { customSubscribe } = this.props
        const message = get(customSubscribe, "successMessage", success)
        this.showSucessMessage(message)
      }).catch((error) => {
        recaptchaRef.current.reset()
        this.showSubscribeError()
      });
  }

  showSucessMessage = (message) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui-alert'>
            <h3>{message}</h3>
            <button onClick={() => {
              onClose();
              this.success();
            }}>
              OK
            </button>
          </div>
        );
      }
    });
  }

  showSubscribeError = () => {
    const { customSubscribe } = this.props;
    const errorMessage = get(customSubscribe, "errorMessage", "This email is already subscribed")

    this.setState({
      loading: false
    });
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui-alert'>
            <h3>{errorMessage}</h3>
            <button onClick={onClose}>OK</button>
          </div>
        );
      }
    });
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleChangeExtraFields = event => {
    this.setState({
      extraFields: {
        ...this.state.extraFields,
        [event.target.name]: event.target.value
      }
    })
  }

  handleStateRegionChange = (val, field) => {
    this.setState({
      extraFields: {
        ...this.state.extraFields,
        [field.name]: val
      }
    })
  }

  changeSelectedOption = (val, field) => {
    this.setState({
      extraFields: {
        ...this.state.extraFields,
        [field.name]: val
      }
    })
  }

  handleCheckboxClick = event => {
    this.setState({
      [event.target.name]: event.target.checked
    })
  }

  renderExtraField = (field) => {

    if (field.type == "textField") {
      return (< input
        type={field.type}
        name={field.name}
        value={this.state.extraFields[field.name] ? this.state.extraFields[field.name] : ""}
        onChange={this.handleChangeExtraFields}
        className='form-field'
        required={field.required}
        placeholder={field.label + (field.required ? " *" : "")} />)
    } else if (field.type == "dropdown") {
      return (
        <div className={'dropdown-style-subscribe'}>
          <SplitButton
            bsSize='large'
            title={this.state.extraFields[field.name] ? this.state.extraFields[field.name] : field.label + (field.required ? " *" : "")} id={field.label}>
            {field.options.map(option => <MenuItem
              eventKey={option}
              key={option}
              active={this.state.extraFields[field.name] === option}
              onSelect={(e) => this.changeSelectedOption(e, field)}>
              {option}
            </MenuItem>)}
          </SplitButton>
        </div>
      )
    } else {
      return (<RegionDropdown
        className="selectDropDown"
        id={field.name}
        name={field.name}
        country={'United States'}
        value={this.state.extraFields[field.name]}
        onChange={(e) => this.handleStateRegionChange(e, field)}
        showDefaultOption={true}
        defaultOptionLabel={field.label + (field.required ? " *" : "")}
      />)
    }
  }

  extraFieldsColumnSize = (index, total) => {
    let lastPosition = total >= 1 ? total - 1 : total
    if (index == lastPosition && !(lastPosition % 2)) {
      return 12
    }
    return 6
  }

  getDefaultFields = (customSubscribe) => {
    let fields = [];
    const isHiding = customSubscribe && customSubscribe.hideDefaultFields;
    const isRequired = customSubscribe && customSubscribe.mobileFieldRequired ? " *" : ""

    if (!isHiding || !customSubscribe.hideDefaultFields.name) {
      fields.push({ name: "name", placeholder: "First Name *", value: this.state.name, type: "text" });
    }

    if (!isHiding || !customSubscribe.hideDefaultFields.lastName) {
      fields.push({ name: "lastName", placeholder: "Last Name *", value: this.state.lastName, type: "text" });
    }

    if (!isHiding || !customSubscribe.hideDefaultFields.email) {
      fields.push({ name: "email", placeholder: "Email *", value: this.state.email, type: "text" });
    }

    if (!isHiding || !customSubscribe.hideDefaultFields.mobileNumber) {
      fields.push({ name: "mobileNumber", placeholder: `Mobile Number${isRequired}`, value: this.state.mobileNumber, type: "text" });
    }

    return fields;
  }

  render() {
    const { customSubscribe, embedMode } = this.props
    const isRequired = customSubscribe && customSubscribe.mobileFieldRequired ? " *" : ""
    const numberOfExtraFields = customSubscribe ? (customSubscribe.extraFields ? customSubscribe.extraFields.length : 0) : 0
    const fields = this.getDefaultFields(customSubscribe);
    const borderRadiusStyle = get(this.props.config.stringValues, 'site.buttons.borderRadius', '9px')
    const privacyPolicyUrl = get(this.props.config.stringValues, 'site.footer.privacyPolicyUrl', '');
    const termsAndConditionsUrl = get(this.props.config.stringValues, 'site.footer.termsAndConditionsUrl', '');

    let styleOrangeContainer = {};
    let styleSignUpButton = {};
    let styleFormFields = {};
    let styleMainTitle = {};
    let styleSubTitle = {};
    let styleDisableSignUpButton = {};
    let styleOptIn = { fontSize: '13px' };
    let customStyleOptIn = {};

    if (get(this.props.config.stringValues, 'site.signup.customStyles')) {
      styleOrangeContainer = {
        borderTop: `20px solid ${get(this.props.config.stringValues, 'site.signup.customStyles.stripeColor')}`,
      };

      styleSignUpButton = {
        backgroundColor:  get(this.props.config.stringValues, 'site.signup.customStyles.buttonColor'),
      }

      styleDisableSignUpButton = {
        color:  get(this.props.config.stringValues, 'site.signup.customStyles.buttonFontDisabledColor'),
      }

      styleFormFields = {
        backgroundColor:  get(this.props.config.stringValues, 'site.signup.customStyles.formFieldColor'),
      }

      styleMainTitle = {
        color:  get(this.props.config.stringValues, 'site.signup.customStyles.mainTitleColor'),
      }

      styleSubTitle = {
        color:  get(this.props.config.stringValues, 'site.signup.customStyles.subTitleColor'),
      }

      customStyleOptIn = {
        color:  get(this.props.config.stringValues, 'site.signup.customStyles.optInConsentColor'),
      }
    }

    styleOptIn = { ...styleOptIn, ...customStyleOptIn }
    const consentTextStyle = { marginBottom: '0', marginTop: '0' }

    return (
      <div className={!embedMode ? 'orange-container' : ''} style={!embedMode ? styleOrangeContainer : {} }>
        <Style
          scopeSelector=".body"
          rules={{
            backgroundColor: get(this.props.config.stringValues, 'site.signup.customStyles.backgroundColor', 'white'),
          }}
        />

        <div className='container'>
          {!embedMode &&
            <div className='main-title' style={styleMainTitle}
            >
              {customSubscribe && customSubscribe.title ? customSubscribe.title : "Sign Up"}
            </div>
          }
          <div className='subscribe'>
            {this.state.error &&
              <div className='alert alert-danger'>
                <span className='error'>{this.state.error}</span>
              </div>
            }
            <Grid fluid>
              <Row>

                <div className='subscribe-form'>
                  {!embedMode &&
                    <div className='subscribe-advice' style={styleSubTitle}>
                      {customSubscribe && customSubscribe.subtitle ? customSubscribe.subtitle : "Sign Up for Real-time Updates"}
                    </div>
                  }

                  <Col md={8} mdOffset={2} xsOffset={0} xs={12} className='form-container'>
                    {fields.map(field =>
                      <Col sm={12} md={6} key={field.name}>
                        <input
                          type={field.type}
                          name={field.name}
                          value={field.value}
                          onChange={this.handleChange}
                          className='form-field'
                          required
                          placeholder={field.placeholder}
                          style={styleFormFields}/>
                      </Col>
                    )}

                    {customSubscribe && customSubscribe.extraFields && customSubscribe.extraFields.map((field, i) =>
                      <Col sm={12} md={this.extraFieldsColumnSize(i, numberOfExtraFields)} key={field.name}>
                        {this.renderExtraField(field)}
                      </Col>
                    )}

                  </Col>

                  <Col md={8} mdOffset={2} xsOffset={0} xs={12} style={{ padding: '30px 15px 0px' }}>
                    <label style={{ marginBottom: '0px'}}>
                      <input type='checkbox' id='messagingAgreement' name='messagingAgreement'
                             checked={this.state.messagingAgreement} onClick={this.handleCheckboxClick} />
                    </label>
                    <span style={styleOptIn}>
                      {privacyPolicyUrl && termsAndConditionsUrl ? (
                        <>
                          <span style={consentTextStyle}>
                          &nbsp; {this.charityName} - By providing your phone number, you agree to receive important updates, donor communications, and volunteer opportunities from {this.charityName}.
                          </span>
                          <p style={consentTextStyle}>
                            Standard message and data rates may apply. Consent is not a condition of any donation. Message frequency may vary.
                          </p>
                          <p style={consentTextStyle}>
                            Text HELP for assistance. Text STOP to opt-out. <a href={termsAndConditionsUrl} target="_blank" rel="noopener noreferrer">See Terms</a> and{' '}
                            <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                          </p>
                        </>
                      ) : (
                        <> &nbsp; I agree to receive SMS/MMS messaging from {this.charityName} </>
                      )}
                    </span>
                  </Col>

                  <Col md={8} mdOffset={2} xs={12} className="center-padding-recaptcha">
                    <Row className={"rowPaddingRecaptcha"}>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={this.props.config.recaptchaSiteKey}
                        onChange={this.submitRecaptcha}
                      />
                    </Row>
                  </Col>

                  <Style
                    scopeSelector='.center-padding'
                    rules={{
                      'button': {
                        borderRadius: borderRadiusStyle
                      }
                    }}
                  />
                  <Col md={8} mdOffset={2} xsOffset={2} xs={8} className="center-padding">
                    <button disabled={!this.allFieldsReady() || this.state.loading} onClick={this.subscribe} className={`center-btn ${!this.allFieldsReady() || this.state.loading ? 'disableButton' : ''}`}
                    style={this.allFieldsReady() ? styleSignUpButton : styleDisableSignUpButton}
                    >
                      {customSubscribe && customSubscribe.buttonLabel ? customSubscribe.buttonLabel.toUpperCase() : "SIGN UP"}
                    </button>
                  </Col>
                </div>

                <Col sm={2} md={1} />
              </Row>
            </Grid>
            <div className='clear' />
            {!embedMode &&
              <div className='form-separator' />
            }
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  config: state.config
})

const mapDispatchToProps = (dispatch) => {
  return {
    userActions: bindActionCreators(userActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Subscribe)
